import React from "react";
import SafeHtml from "../SafeHtml/SafeHtml";
import { Box, Modal, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BuilderBlocks } from "@builder.io/react";

interface LightboxProps {
  trigger: string;
  builderBlock?: any;
}

const Lightbox: React.FC<LightboxProps> = ({ trigger, builderBlock }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Box onClick={handleOpen}>
        <SafeHtml
          as="div"
          html={trigger}
          className="builder-io-heading-component"
        />
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="builder-lightbox"
        sx={{
          "& .Mui-focusVisible": {
            outline: "none",
          },
          "& *:focus": {
            outline: "none",
          },
        }}
      >
        <Box
          onClick={handleClose}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 4,
          }}
        >
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              position: "relative",
              bgcolor: "background.paper",
              borderRadius: 2,
              p: 2,
            }}
          >
            {/* Close button in top right corner */}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 5,
                top: 0,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>

            <Box onClick={handleClose}>
              <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                  position: "relative",
                  width: "100%",
                  maxWidth: 830,
                  maxHeight: "80vh",
                  overflowY: "auto",
                  mt: 2,
                }}
              >
                <BuilderBlocks
                  blocks={builderBlock?.children}
                  dataPath="children"
                  parentElementId={builderBlock?.id}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Lightbox;

export const lightBoxRegistration = {
  name: "Lightbox",
  inputs: [
    {
      name: "trigger",
      type: "richText",
    },
  ],
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/format-text.svg",
  description: "Add a Lightbox component to the page",
  canHaveChildren: true,
  defaultChildren: [],
};
